module.exports = __webpack_public_path__ + "static/media/react.6e592ec4.svg";